export default {
  dockPanel: 'Airport',
  rcPanel: 'Remote Controller',
  noDrone: 'No Drone',
  currentProject: 'Current Project',

  switchProjectFailed: 'Failed to switch project',
  noAvailableDock: 'No available airport device found',

  dockNotConnected: 'Airport is offline. Detail panel unavailable',
  deviceNotConnected: 'Aircraft is offline. Detail panel unavailable',
  hideDetailPanel: 'Hide detail panel',
  showDetailPanel: 'Show detail panel',

  noAlarm: 'No alarms',
  alarmTitle: 'Alarms',
  alarmCount: '{count} total',
  close: 'Close',
  confirmRead: 'Mark as read',
  viewAllAlarms: 'View all {count} alarms',
  workspaceNotFoundForHms: 'Workspace not found. Cannot mark as read',
  confirmReadSuccess: 'Marked as read',
  markReadFailed: 'Failed to mark as read',

  deviceMode: {
    0: 'Standby',
    1: 'Takeoff Preparing',
    2: 'Takeoff Ready',
    3: 'Manual Flight',
    4: 'Auto Takeoff',
    5: 'Wayline Flight',
    6: 'Panorama',
    7: 'Smart Track',
    8: 'ADS-B Avoidance',
    9: 'Auto RTH',
    10: 'Auto Landing',
    11: 'Forced Landing',
    12: 'Three-blade Landing',
    13: 'Upgrading',
    14: 'Disconnected',
    15: 'APAS',
    16: 'Virtual Stick',
    17: 'Command Flight',
  },

  dockMode: {
    disconnected: 'Disconnected',
    0: 'Idle',
    1: 'On-site Debug',
    2: 'Remote Debug',
    3: 'Firmware Upgrading',
    4: 'Working',
  },
}
